import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyNiche = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 274,
	height: 258,
	viewBox: "0 0 274 258",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M141.854 248.45C68.5 249.746 16.7213 236.045 0 229.033C38.2939 183.187 132.146 180.491 192.015 190.198C239.911 197.964 269.864 219.692 274 229.033C260.515 234.966 215.21 247.155 141.854 248.45Z",
			fill: "url(#paint0_linear_11083_50508)",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.539 257.91C208.734 257.91 266.449 200.195 266.449 129C266.449 57.8051 208.734 0.090332 137.539 0.090332C66.3442 0.090332 8.62939 57.8051 8.62939 129C8.62939 200.195 66.3442 257.91 137.539 257.91Z",
			fill: "url(#paint1_linear_11083_50508)",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.2938 86.0223C70.2938 78.861 76.1035 73.0513 83.2649 73.0513H72.5966C65.4352 73.0513 59.6255 78.861 59.6255 86.0223V94.7271H70.2938V86.0223Z",
			fill: "url(#paint2_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.2938 180.532V94.7278H59.6255V180.532C59.6255 187.693 65.4352 193.503 72.5966 193.503H83.2649C76.0912 193.503 70.2938 187.693 70.2938 180.532Z",
			fill: "url(#paint3_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.591 73.0513H190.923H83.2514C76.09 73.0513 70.2803 78.861 70.2803 86.0223V94.7271H203.906H214.574V86.0223C214.574 78.8511 208.765 73.0513 201.591 73.0513Z",
			fill: "url(#paint4_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.905 94.7278H70.2915V180.532C70.2915 187.693 76.1012 193.503 83.2626 193.503H190.936H201.605C208.766 193.503 214.576 187.693 214.576 180.532V94.7278H203.905Z",
			fill: "url(#paint5_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1415 87.8421C83.0609 87.8421 84.614 86.2864 84.614 84.3695C84.614 82.4526 83.0584 80.897 81.1415 80.897C79.2221 80.897 77.6689 82.4526 77.6689 84.3695C77.6689 86.2864 79.2221 87.8421 81.1415 87.8421Z",
			fill: "url(#paint6_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.4003 87.8421C92.3197 87.8421 93.8728 86.2864 93.8728 84.3695C93.8728 82.4526 92.3172 80.897 90.4003 80.897C88.4834 80.897 86.9277 82.4526 86.9277 84.3695C86.9277 86.2864 88.4809 87.8421 90.4003 87.8421Z",
			fill: "url(#paint7_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.661 87.8421C101.58 87.8421 103.134 86.2864 103.134 84.3695C103.134 82.4526 101.578 80.897 99.661 80.897C97.7441 80.897 96.1885 82.4526 96.1885 84.3695C96.1885 86.2864 97.7441 87.8421 99.661 87.8421Z",
			fill: "url(#paint8_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163.721 135.307C166.864 136.723 166.864 141.185 163.721 142.601L129.209 158.153C126.561 159.346 123.565 157.41 123.565 154.506L123.565 123.402C123.565 120.499 126.561 118.562 129.209 119.755L163.721 135.307Z",
			fill: "url(#paint9_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.363 211.002C73.0632 202.447 81.7728 185.296 86.167 177.788C89.556 185.802 97.0884 201.455 97.0884 211.002C97.0884 220.194 90.3104 220.926 86.167 220.926C82.0235 220.928 73.739 221.693 73.363 211.002Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.18 195.891C56.9736 190.12 62.9136 178.545 65.9094 173.475C68.2219 178.892 73.3558 189.452 73.3558 195.891C73.3558 202.094 68.7356 202.59 65.9094 202.59C63.0831 202.59 57.4356 203.106 57.18 195.891Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.155 211.745C185.005 207.548 189.325 199.129 191.503 195.441C193.185 199.381 196.919 207.062 196.919 211.745C196.919 216.256 193.559 216.618 191.503 216.618C189.45 216.618 185.342 216.995 185.155 211.745Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.105 172.997L203.917 175.435L213.538 196.061L218.78 193.591L209.105 172.997Z",
			fill: "#E2E2E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.491 120.172C161.77 128.036 154.586 147.96 162.45 164.681C170.315 181.403 190.238 188.586 206.959 180.722C223.681 172.858 230.864 152.934 223 136.213C215.136 119.491 195.212 112.32 178.491 120.172ZM202.32 170.852C191.057 176.148 177.628 171.317 172.33 160.044C167.034 148.771 171.865 135.353 183.138 130.054C194.401 124.758 207.829 129.59 213.128 140.862C218.427 152.135 213.583 165.556 202.32 170.852Z",
			fill: "#E2E2E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.491 120.172C161.77 128.036 154.586 147.96 162.45 164.681C170.315 181.403 190.238 188.586 206.959 180.722C223.681 172.858 230.864 152.934 223 136.213C215.136 119.491 195.212 112.32 178.491 120.172ZM202.32 170.852C191.057 176.148 177.628 171.317 172.33 160.044C167.034 148.771 171.865 135.353 183.138 130.054C194.401 124.758 207.829 129.59 213.128 140.862C218.427 152.135 213.583 165.556 202.32 170.852Z",
			fill: "url(#paint10_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.559 165.585C209.942 156.384 209.271 142.123 200.065 133.74C190.859 125.357 176.598 126.028 168.215 135.229C159.832 144.443 160.503 158.702 169.709 167.085C178.918 175.467 193.179 174.796 201.559 165.585Z",
			fill: "#C9C9C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.831 185.813L208.091 191.799L224.335 226.405L237.098 220.406L220.831 185.813Z",
			fill: "#E2E2E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.037 176.796L210.725 197.378L213.541 196.063L203.92 175.437L201.037 176.796Z",
			fill: "#C9C9C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.105 172.998L203.917 175.436L213.538 196.062L218.78 193.592L209.105 172.998Z",
			fill: "url(#paint11_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.491 120.173C161.77 128.037 154.586 147.961 162.45 164.682C170.315 181.404 190.238 188.587 206.959 180.723C223.681 172.859 230.864 152.935 223 136.214C215.136 119.492 195.212 112.321 178.491 120.173ZM202.32 170.853C191.057 176.149 177.628 171.318 172.33 160.045C167.034 148.772 171.865 135.353 183.138 130.055C194.401 124.759 207.829 129.59 213.128 140.863C218.427 152.136 213.583 165.557 202.32 170.853Z",
			fill: "#C9C9C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.403 165.586C217.786 156.385 217.115 142.124 207.909 133.741C198.703 125.358 184.442 126.029 176.059 135.23C167.676 144.444 168.347 158.703 177.553 167.086C186.761 175.468 201.023 174.797 209.403 165.586Z",
			fill: "url(#paint12_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.43 194.003L219.696 228.586L224.334 226.406L208.089 191.801L203.43 194.003Z",
			fill: "#C9C9C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.831 185.814L208.091 191.8L224.335 226.406L237.098 220.407L220.831 185.814Z",
			fill: "url(#paint13_linear_11083_50508)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_11083_50508",
				x1: 137,
				y1: 195.592,
				x2: 137,
				y2: 254.383,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D9D9D9" }), /* @__PURE__ */ _jsx("stop", {
					offset: .8003,
					stopColor: "#737373",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_11083_50508",
				x1: 137.538,
				y1: -78.1182,
				x2: 137.538,
				y2: 232.019,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D9D9D9" }), /* @__PURE__ */ _jsx("stop", {
					offset: .8003,
					stopColor: "#737373",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_11083_50508",
				x1: 72.6145,
				y1: 71.6638,
				x2: 69.0647,
				y2: 93.9972,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ECEBEB" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B7B7B7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_11083_50508",
				x1: 80.323,
				y1: 133.164,
				x2: 47.7284,
				y2: 173.372,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E7E7E7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D0CFCF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_11083_50508",
				x1: 142.73,
				y1: 79.9169,
				x2: 142.304,
				y2: 94.5222,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E7E7E7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D0CFCF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_11083_50508",
				x1: 142.432,
				y1: 94.7277,
				x2: 142.432,
				y2: 193.503,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFFCFC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ECECEC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_11083_50508",
				x1: 81.1406,
				y1: 80.8954,
				x2: 81.1406,
				y2: 87.8411,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFFCFC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ECECEC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_11083_50508",
				x1: 90.4003,
				y1: 80.8954,
				x2: 90.4003,
				y2: 87.8411,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFFCFC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ECECEC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_11083_50508",
				x1: 99.6619,
				y1: 80.8954,
				x2: 99.6619,
				y2: 87.8411,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFFCFC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ECECEC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint9_linear_11083_50508",
				x1: 174.492,
				y1: 147.991,
				x2: 109.728,
				y2: 133.612,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ECEBEB" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B7B7B7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint10_linear_11083_50508",
				x1: 192.725,
				y1: 116.989,
				x2: 192.725,
				y2: 183.911,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFFCFC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ECECEC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint11_linear_11083_50508",
				x1: 211.012,
				y1: 181.522,
				x2: 212.815,
				y2: 197.541,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E7E7E7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D0CFCF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint12_linear_11083_50508",
				x1: 177.112,
				y1: 130.319,
				x2: 226,
				y2: 195.592,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ECEBEB" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B7B7B7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint13_linear_11083_50508",
				x1: 222.058,
				y1: 200.808,
				x2: 224.925,
				y2: 229.06,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E7E7E7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D0CFCF"
				})]
			})
		] })
	]
});
export { SvgEmptyNiche as ReactComponent };
export { default } from "/home/runner/work/frontend_insights/frontend_insights/apps/insights/src/assets/images/svg/topics/empty-niche.svg?url";
